import React from 'react';
import './scss/loading-animation.scss';

const LoadingAnimation = () => {
// export default function LoadingAnimation() {
  return (
    <div className="loading-animation">
      <div className="filter-skeleton">
        <div className="skeleton skeleton-title">
          &nbsp;
        </div>
        <div className="skeleton skeleton-checkbox">
          &nbsp;
        </div>
        <div className="skeleton skeleton-checkbox">
          &nbsp;
        </div>
      </div>
      <div className="filter-skeleton">
        <div className="skeleton skeleton-title">
          &nbsp;
        </div>
        <div className="skeleton skeleton-input">
          &nbsp;
        </div>
        <div className="skeleton skeleton-input">
          &nbsp;
        </div>
      </div>
  </div>
  );
}

export default LoadingAnimation;